import { z } from 'zod';
export const PASSWORD_MIN_LENGTH = 10;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Mindestens ${PASSWORD_MIN_LENGTH} Zeichen`)
    .max(256, 'Höchstens 256 Zeichen')
    .refine((v) => /[a-zäöüß]/.test(v) && /[A-ZÄÖÜ]/.test(v), 'Groß- und Kleinbuchstaben verwenden')
    .refine((v) => /\d/.test(v) || /[^A-Za-z0-9]/.test(v), 'Mindestens eine Ziffer oder ein Sonderzeichen');
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email('Ungültige E-Mail-Adresse')
    .max(254);
export const slugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,46}[a-z0-9])?$/, 'Nur Kleinbuchstaben, Ziffern und Bindestriche');
export const hexColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Farbe im Format #RRGGBB');
export const domainSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$|^localhost$/, 'Ungültiger Domainname');
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Passwort erforderlich').max(256),
});
export const passwordResetRequestSchema = z.object({ email: emailSchema });
export const passwordResetSchema = z.object({
    token: z.string().min(20).max(200),
    password: passwordSchema,
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(256),
    newPassword: passwordSchema,
});
export const tenantProfileSchema = z.object({
    name: z.string().trim().min(2).max(120),
    legalName: z.string().trim().max(200).nullish(),
    email: z.string().trim().toLowerCase().email().max(254).nullish().or(z.literal('')),
    phone: z.string().trim().max(50).nullish(),
    website: z.string().trim().max(200).nullish(),
    street: z.string().trim().max(200).nullish(),
    postalCode: z.string().trim().max(20).nullish(),
    city: z.string().trim().max(100).nullish(),
    country: z.string().trim().length(2).toUpperCase().default('DE'),
    vatId: z.string().trim().max(30).nullish(),
    timezone: z.string().trim().min(1).max(64),
    primaryColor: hexColorSchema,
    accentColor: hexColorSchema.nullish(),
    portalSelfRegistration: z.boolean().default(false),
    repairSlipQr: z.boolean().default(true),
    repairPublicStatus: z.boolean().default(true),
    ticketGuestAccess: z.boolean().default(true),
});
//# sourceMappingURL=schemas.js.map